<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="系统ID：" prop="system_id">
                <el-input v-model="model.system_id"></el-input>
            </el-form-item>
            <el-form-item label="第三方用户名：" prop="third_username">
                <el-input v-model="model.third_username"></el-input>
            </el-form-item>
            <el-form-item label="本平台用户名：" prop="username">
                <el-input v-model="model.username"></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <el-select clearable v-model="model.state" placeholder="请选择">
                    <el-option v-for="item in enuObj('userstate')" :key="'userstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'singleSignOnEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                system_id: '',
                third_username: '',
                username: '',
                state: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/singlesignon/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['userstate'],
            rules: {
                system_id: [
                    {required: true, message: '系统ID不能为空', trigger: 'blur'}
                ],
                third_username: [
                    {required: true, message: '第三方用户名不能为空', trigger: 'blur'}
                ],
                username: [
                    {required: true, message: '本平台用户名不能为空', trigger: 'blur'}
                ],
                state: [
                    {required: true, message: '状态不能为空', trigger: 'blur'}
                ]
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/singlesignon/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.state = this.model.state+""
        },
    }
};
</script>